import { createSelector } from 'reselect';
import { getBankAccounts } from '@/selectors/merchant';

export const getPersistedBankAccounts = createSelector(
  getBankAccounts,
  bankAccounts => bankAccounts,
);
